import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class SubItem2 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item2">
                <Row style={{backgroundColor: "f4f4f4", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Oportunidades de trabajo</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El profesional egresado de nuestra institución tiene capacidades para desarrollar su actividad en forma independiente o como integrante de equipos de trabajo en instituciones privadas o públicas vinculadas a la producción de medios gráficos, digitales y audiovisuales. Podrá desempeñarse en: Estudios de Diseño, Branding y manejo de Imagen Corporativa, Empresas de Comunicación Visual, Empresas de comunicación impresa, Agencias de Publicidad, Empresas de Marketing, Estudios de Fotografía, Agencias de Desarrollo Web y Social Media. Diseñador freelance.
                        </div>
                    </Col>
                    <Col md={4}>
                    
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem2;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoGrafico/SubItem2.jsx